import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../UI/Button/Button';
import {showOverlay} from '../actions/overlay-actions';
import Translation from '../lang/Translation';
import isUsingArtemisStyles from '../selectors/isUsingArtemisStyles';

const useStyles = createUseStyles({
  InputFieldHelpLabel: {
    color: props => !props.isUsingArtemisStyles && '#333',
  },
});

export function InputFieldHelpLabel(props) {
  const classes = useStyles(props);
  return (
    <Button
      link
      data-test="InputFieldHelpLabel"
      id={`InputFieldHelpLabel__${props.fieldName}`}
      className={classes.InputFieldHelpLabel}
      onClick={() => props.showOverlay(props.overlay)}
      leftAlign={props.leftAlign}
    >
      <Translation>{props.linkTranslationKey}</Translation>
    </Button>
  );
}

InputFieldHelpLabel.propTypes = {
  linkTranslationKey: PropTypes.string,
  fieldName: PropTypes.string,
  overlay: PropTypes.string,
  showOverlay: PropTypes.func.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
  leftAlign: PropTypes.bool,
};

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

const mapDispatchToProps = dispatch => ({
  showOverlay(overlay) {
    dispatch(showOverlay(overlay));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InputFieldHelpLabel);
